import { Component, OnInit } from '@angular/core';
import { CierreTurnoService } from '@cierreTurno/cierre-turno.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Contacto } from '@shared/models/cierreTurno/Contacto';
import { MessageService } from '@shell/message.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ContactosDetalleComponent } from '../contactos-detalle/contactos-detalle.component';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-contactos-lista',
  templateUrl: './contactos-lista.component.html',
  styleUrl: './contactos-lista.component.scss'
})
export class ContactosListaComponent implements OnInit{

  cargandoLista:boolean = false;
  contactos: Contacto[];
  contactosFiltrados: Contacto[];
  contactoSeleccionado: Contacto;
  buscadorFormControl = new FormControl();

  constructor(
    private messageService: MessageService,
    private cierreTurnoService: CierreTurnoService,
    private modal: NgbModal,
    private spinner: NgxSpinnerService) { 
  }

  ngOnInit(): void {
    this.buscador.setValue('');
    this.contactoSeleccionado = null;
    this.obtenerContactos();
  }

  mostrarSpinner() {
    this.spinner.show('spinnerGrafico');
    this.cargandoLista = true;
  }
  
  ocultarSpinner() {    
    this.spinner.hide('spinnerGrafico');
    this.cargandoLista = false;
  }

  async obtenerContactos() {
    this.mostrarSpinner();
    try {
      const listContactos = await this.cierreTurnoService.getContactos();
      this.contactos = listContactos.sort((a, b) => { if (a.nombre > b.nombre) { return 1 } else { return -1 } });
      this.contactosFiltrados = this.contactos;
      this.ocultarSpinner();
    } catch (error) {
      this.ocultarSpinner();
      this.messageService.showErrorMessage('Hubo un error al obtener los contactos.');
    }    
  }

  usuarioSeleccionoContacto(i:number) {    
    this.contactoSeleccionado = this.contactosFiltrados[i];
  }

  abrirModal() {
    const modalRef = this.modal.open(ContactosDetalleComponent, { centered: true, backdrop: 'static', size: 'lg' });
    modalRef.componentInstance.contactoSeleccionado = null;
  
    modalRef.componentInstance.recargarListaDeContactos.subscribe((recargar: boolean) => {
      if (recargar) {
        this.obtenerContactos();
        this.buscador.setValue('');
        this.contactoSeleccionado = null;
      }
    });
  }
  

  filtrarContactos() {
    const textoBuscado = this.buscador.value;

    this.contactosFiltrados = this.contactos.filter(g => {
      let agregar = true;
      if (textoBuscado && textoBuscado.length>2) {
        agregar = g.nombre.toLowerCase().indexOf(textoBuscado.toLowerCase()) > -1;
        agregar = agregar || g.numero.toLowerCase().indexOf(textoBuscado.toLowerCase()) > -1;
        agregar = agregar || g.email.toLowerCase().indexOf(textoBuscado.toLowerCase()) > -1;
      }
      return agregar;
    });
  }

  get buscador() {
    return this.buscadorFormControl;
  }
}
